import React from 'react';

/**
 * Error boundary per catturare errori di rendering e mostrare un messaggio invece di crash.
 * Utile per UX: l'utente vede un messaggio e può tornare alla home o ricaricare.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const { fallback } = this.props;
      if (typeof fallback === 'function') {
        return fallback(this.state.error, () => this.setState({ hasError: false, error: null }));
      }
      return (
        <div className="vc-error-boundary" role="alert">
          <div className="container py-5 text-center">
            <h2 className="h4 mb-3">Si è verificato un errore</h2>
            <p className="text-muted mb-4">
              Qualcosa non ha funzionato. Puoi provare a ricaricare la pagina o tornare alla home.
            </p>
            <div className="d-flex gap-2 justify-content-center flex-wrap">
              <a href="/" className="btn btn-primary">Torna alla home</a>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => window.location.reload()}
              >
                Ricarica pagina
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
